import React from 'react'
import "./Success_modal.css"
import Successfull_Lottie from '../../animation/Successfull_Lottie/Successfull_Lottie'
import { Modal } from 'react-bootstrap'

function Success_modal({successText, ...props}) {
  return (
   <>
  <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='Success_modal'
    >
     
      <Modal.Body>
        <Successfull_Lottie successText={successText}/>
      </Modal.Body>
    </Modal>
   </>
  )
}

export default Success_modal